var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsDateString, IsString, IsUUID } from 'class-validator';
import { CustomFormElementLiteDto } from './custom-form-element.lite.dto.js';
export class CustomFormLiteDto {
    id;
    createdAt;
    updatedAt;
    title;
    description;
    isDefaultForm;
    visibleForPatients;
    officeId;
    customFormElements;
}
__decorate([
    IsUUID(),
    Expose(),
    IsString(),
    __metadata("design:type", String)
], CustomFormLiteDto.prototype, "id", void 0);
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", Date)
], CustomFormLiteDto.prototype, "createdAt", void 0);
__decorate([
    Exclude(),
    IsDateString(),
    __metadata("design:type", Date)
], CustomFormLiteDto.prototype, "updatedAt", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], CustomFormLiteDto.prototype, "title", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], CustomFormLiteDto.prototype, "description", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], CustomFormLiteDto.prototype, "isDefaultForm", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], CustomFormLiteDto.prototype, "visibleForPatients", void 0);
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], CustomFormLiteDto.prototype, "officeId", void 0);
__decorate([
    Expose(),
    IsArray(),
    Type(() => CustomFormElementLiteDto),
    __metadata("design:type", Array)
], CustomFormLiteDto.prototype, "customFormElements", void 0);
//# sourceMappingURL=custom-form.lite.dto.js.map